const getOrderOp = (order: string | string[]) =>
  -(typeof order === "string"
    ? ["asc", "_", "desc"].findIndex((v) => v.startsWith(order.toLowerCase())) -
      1
    : -1);

// prettier-ignore
// need dangling comma
const compare = <T,>(a: T, b: T) => (a > b ? 1 : -1);

type KeyOrKeyFunc<T> = keyof T | ((item: T) => T);
// prettier-ignore
// need dangling comma
const getSortValue = <T,>(object: T, keyOrKeyFunc: KeyOrKeyFunc<T>) =>
  keyOrKeyFunc
    ? typeof keyOrKeyFunc === "function"
      ? keyOrKeyFunc(object)
      : object[keyOrKeyFunc] || 0
    : object;

const orderArrayBy = <TObj, TCollection extends TObj[]>(
  collection: TCollection,
  keyOrKeys: (keyof TObj)[] | keyof TObj,
  order: string | string[],
): TCollection =>
  Array.isArray(collection)
    ? Array.isArray(keyOrKeys)
      ? [...keyOrKeys]
          .reverse()
          .map((key, index) =>
            orderArrayBy<TObj, TCollection>(
              collection,
              key,
              Array.isArray(order) && order.length > index
                ? order[index]
                : order,
            ),
          )
        ? collection
        : collection
      : collection.sort(
          (a, b) =>
            compare(getSortValue(a, keyOrKeys), getSortValue(b, keyOrKeys)) *
            getOrderOp(order),
        )
    : collection;

export default orderArrayBy;
